export const environment = {
  production: true,
   firebaseConfig : {
    apiKey: "AIzaSyCokwCtPPh3boFprzQ9aboX7urGBzquhXM",
    authDomain: "membershipdevunited.firebaseapp.com",
    databaseURL: "https://membershipdevunited.firebaseio.com",
    projectId: "membershipdevunited",
    storageBucket: "membershipdevunited.appspot.com",
    messagingSenderId: "251579830253"
}, // URL of development API
apiUrl: 'http://ec2-13-56-150-107.us-west-1.compute.amazonaws.com:4567/api/v2',
//apiUrl:'http://35.185.212.75:4567/api/v2',
masterToken:'3afd2d4b-7902-4a88-afbe-d0bb8df3538c',
//masterToken:'e88e6765-0c8a-4041-9ede-6e2e6eabc1da',
adminToken:'84efe884-5d37-4a94-abf2-9029dd6a8708'

}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/environments/environment.ts